import { Reveal } from "@/components/Motion";
import { HIGHLIGHTS } from "@/data/content";

const Highlights = () => {
  return (
    <section
      id="highlights"
      data-testid="highlights"
      className="relative py-28 md:py-36 bg-[#0a0a12]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#16fcfb]">
              [ 003 ] HCASP Highlights
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display font-700 text-4xl md:text-5xl leading-[1.05] tracking-tight text-white">
              Built for practitioners, not spectators.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#3d414f] border border-[#3d414f] rounded-2xl overflow-hidden">
          {HIGHLIGHTS.map((h, i) => (
            <Reveal key={h.n} delay={0.05 * i} className="h-full">
              <div
                data-testid={`highlight-${h.n}`}
                className="group h-full bg-[#07070c] p-8 md:p-10 transition-colors duration-300 hover:bg-[#404452]/30"
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono2 text-sm text-[#4d4479] group-hover:text-[#16fcfb] transition-colors duration-300">
                    {h.n}
                  </span>
                  <span className="h-1.5 w-1.5 rounded-full bg-[#3d414f] group-hover:bg-[#16fcfb] transition-colors duration-300" />
                </div>
                <h3 className="mt-8 font-display font-600 text-xl text-white">
                  {h.title}
                </h3>
                <p className="mt-3 font-body text-sm text-white/60 leading-relaxed">
                  {h.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
